<ng-content></ng-content>
@if (address?.streetAddress1) {
  <span>{{ address.streetAddress1 }}</span>
}
@if (address?.streetAddress2) {
  <span>{{ address.streetAddress2 }}</span>
}
@if (address?.getAddressLine3()) {
  <span>{{ address.getAddressLine3() }}</span>
}
@if (address?.country) {
  <span>{{ address.country | countryName | async }}</span>
}
@if (address.validationStatus && !hideStatus) {
  <span fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
    @if (address.validationStatus === 'Success') {
      <mat-icon class="success">check_circle</mat-icon>
    }
    @if (address.validationStatus === 'Warning') {
      <mat-icon color="accent">warning</mat-icon>
    }
    @if (address.validationStatus === 'Error') {
      <mat-icon color="warn">warning</mat-icon>
    }
    <span>{{ address.validationMessage }}</span>
  </span>
}
